import React, { useState } from "react";
import AdventCard from "./AdventCard";
import "../../styles/pages/cardd.css"

const data = [
  { id: 1, text: "Decorate the house" },
  { id: 2, text: "Watch Christmas Mickey Mouse movie" },
  { id: 3, text: "Buy a Christmas tree" },
  { id: 4, text: "Buy presents" },
  { id: 5, text: "Go to shoping" },
  { id: 6, text: "Clean up your toys when you’re finished playing" },
  { id: 7, text: "Put your Dirty Clothes in the Hamper" },
  { id: 8, text: "Fetch stuff from your parent(s)" },
  { id: 9, text: "Help with the Dishes" },
  { id: 10, text: "Pick out your Pajamas" },
  { id: 11, text: "Help with the Garden" },
  { id: 12, text: "Pick out Your Clothes for School" },
  { id: 13, text: "Set the Dinner Table" },
  { id: 14, text: "Clear your Eating Space" },
  { id: 15, text: "Dry the Dishes" },
  { id: 16, text: "Help with Bathtime" },
  { id: 17, text: "Bring Minecraft to life" },
  { id: 18, text: "Make a bird feeder" },
  { id: 19, text: "Make your own drive-in movie" },
  { id: 20, text: "Make an old-school whirligig fidget toy" },
  { id: 21, text: "Play a board game" },
  { id: 22, text: "Stargaze indoors" },
  { id: 23, text: "Play Don’t wake the giant" },
  { id: 24, text: "Make a race track" },
  { id: 25, text: "Operation time" },
  { id: 26, text: "Make a pair of paper roll binoculars" },
  { id: 27, text: "Make a mini city out of toilet paper rolls" },
  { id: 28, text: "Take to the skies in cardboard planes" },
  { id: 29, text: "Play Simon Says" },
  { id: 30, text: "Do some indoor bowling" },
  { id: 31, text: "Make your Bed" },
];
const AdventCalender = () => {
  const [arr] = useState(data);

  const squares = 8;
  const arrr = Array(squares ** 2).concat(arr);
  const gridSize = "1fr ".repeat(squares);

  return (
    <>
      <div>
        <h1>Advent Calendar</h1>
      </div>
      <div className="card-gridd"
        style={{
          display: "grid",
          gridTemplateColumns: gridSize,
          gridTemplateRows: gridSize,
          gap: "9px",
          rowGap: "7px",
          marginTop: "15px",
        }}
      >
        {arrr.map((t) => (
          <AdventCard key={t.id} t={t} text={t.text} />
        ))}
      </div>
    </>
  );
};

export default AdventCalender;
